/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technical_SpecificationsInputs */

const en_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical Specifications`)
};

const es_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificaciones técnicas`)
};

const fr_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécifications techniques`)
};

const de_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische Spezifikationen`)
};

const ja_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術仕様`)
};

const zh_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术规格`)
};

const ar_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المواصفات الفنية`)
};

const id_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesifikasi Teknis`)
};

const it_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specifiche Tecniche`)
};

const ru_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технические характеристики`)
};

const pt_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificações Técnicas`)
};

const ko_technical_specifications = /** @type {(inputs: Technical_SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기술 사양`)
};

/**
* | output |
* | --- |
* | "Technical Specifications" |
*
* @param {Technical_SpecificationsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const technical_specifications = /** @type {((inputs?: Technical_SpecificationsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technical_SpecificationsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_technical_specifications(inputs)
	if (locale === "es") return es_technical_specifications(inputs)
	if (locale === "fr") return fr_technical_specifications(inputs)
	if (locale === "de") return de_technical_specifications(inputs)
	if (locale === "ja") return ja_technical_specifications(inputs)
	if (locale === "zh") return zh_technical_specifications(inputs)
	if (locale === "ar") return ar_technical_specifications(inputs)
	if (locale === "id") return id_technical_specifications(inputs)
	if (locale === "it") return it_technical_specifications(inputs)
	if (locale === "ru") return ru_technical_specifications(inputs)
	if (locale === "pt") return pt_technical_specifications(inputs)
	return ko_technical_specifications(inputs)
});